module.exports = __webpack_public_path__ + "static/media/bargraph.2776d4f9.svg";